import { Helmet } from 'react-helmet-async';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { buildRoutes } from './routes';
import { TenantBrand } from './theme/TenantBrand';

const router = createBrowserRouter(buildRoutes());

function App() {
  return (
    <>
      <Helmet>
        <title>Panel</title>
        <meta name="description" content="Structured interview feedback" />
      </Helmet>
      {/*
        §2's three white-label properties, applied **above the router** so that `/sign-in` — which is
        outside `AppShell` and is the screen that renders before anybody has a session — wears the
        tenant's brand too (TASK-102). One writer of those properties, and it is this one.
      */}
      <TenantBrand>
        <RouterProvider router={router} />
      </TenantBrand>
    </>
  );
}

export default App;
